__turbopack_context__.v({
  "sections": "ManualsBlok-module__F_rJFa__sections",
  "title": "ManualsBlok-module__F_rJFa__title",
});
